import { actions } from '../actions';

const initialState = [];

export const projectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_PROJECTS_SUCCEED:
      return action.payload;
    case actions.UPDATE_PROJECT_SUCCEED:
      return [
        ...state.filter(({ id }) => id !== action.payload.id),
        action.payload
      ];
    default:
      return state;
  }
};
